@if (field.generateRows) {
  <tablewithfixedrows-component [field]="field" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView"></tablewithfixedrows-component>
}
@if (!field.generateRows) {
  <tablewithvariablerows-component [field]="field" [isUpdate]="isUpdate" [useSummaryView]="useSummaryView"></tablewithvariablerows-component>
}